import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Plus, Pencil, Trash2 } from 'lucide-react';

export function CouponsTab({
  coupons,
  onCreateCoupon,
  onToggle,
  onEdit,
  onDelete,
}) {
  return (
    <Card className="border-slate-200">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg">Coupon Codes</CardTitle>
        <Button onClick={onCreateCoupon} data-testid="create-coupon-btn">
          <Plus className="mr-2 h-4 w-4" />
          Create Coupon
        </Button>
      </CardHeader>
      <CardContent>
        {coupons.length === 0 ? (
          <p className="text-center py-8 text-slate-500">No coupons created yet</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Discount</th>
                  <th>Applies To</th>
                  <th>Uses</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {coupons.map((coupon) => {
                  const plans = coupon.applicable_plans;
                  const cycles = coupon.applicable_cycles;
                  const planLabel = !plans || plans.length === 2
                    ? 'All plans'
                    : plans.map(p => p === 'single' ? 'Single' : 'Multi').join(', ');
                  const cycleLabel = !cycles || cycles.length === 2
                    ? 'All cycles'
                    : cycles.map(c => c === 'monthly' ? 'Monthly' : 'Annual').join(', ');
                  return (
                    <tr key={coupon.id} data-testid={`coupon-${coupon.id}`}>
                      <td className="font-mono font-medium">{coupon.code}</td>
                      <td>{coupon.discount_percent}%</td>
                      <td>
                        <div className="text-xs text-slate-600 leading-tight">
                          <div>{planLabel}</div>
                          <div className="text-slate-400">{cycleLabel}</div>
                        </div>
                      </td>
                      <td>{coupon.current_uses}/{coupon.max_uses || '∞'}</td>
                      <td>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          coupon.active ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-500'
                        }`}>
                          {coupon.active ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>
                        <div className="flex items-center gap-1">
                          <Button
                            variant="ghost"
                            size="sm"
                            data-testid={`toggle-coupon-${coupon.id}`}
                            onClick={() => onToggle(coupon.id)}
                          >
                            {coupon.active ? 'Disable' : 'Enable'}
                          </Button>
                          <Button
                            variant="ghost"
                            size="sm"
                            data-testid={`edit-coupon-${coupon.id}`}
                            onClick={() => onEdit(coupon)}
                            className="text-slate-500 hover:text-blue-600"
                          >
                            <Pencil size={14} />
                          </Button>
                          <Button
                            variant="ghost"
                            size="sm"
                            data-testid={`delete-coupon-${coupon.id}`}
                            onClick={() => onDelete(coupon)}
                            className="text-slate-500 hover:text-red-600"
                          >
                            <Trash2 size={14} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
